import React from 'react';
import { FileText } from 'lucide-react';
import AirBoardPage from './AirBoardPage';
import { SUBESTADOS_COTIZACIONES, subEstadoCotizacion } from '../utils/airBoardConstants';

/**
 * Tablero "Cotizaciones" del aéreo — solicitudes en estado `Borrador`.
 *
 * Acá se piden y cargan las cotizaciones de los proveedores. Una
 * solicitud enviada o esperando respuesta hace más de una semana se ve
 * como "Vencida".
 */
export default function QuotationsBoardPage() {
  return (
    <AirBoardPage
      estado="Borrador"
      titulo="Cotizaciones"
      subtitulo="Solicitudes en estado Borrador · gestiona cotizaciones de proveedores"
      icon={FileText}
      iconClass="bg-amber-100 text-amber-700"
      subEstadoOptions={SUBESTADOS_COTIZACIONES}
      computeSubEstado={subEstadoCotizacion}
      mostrarAntiguedad
      exportFileName="aereo_cotizaciones"
      permiteInvitar
      permiteCargarCotizacion
    />
  );
}
